import { useTranslation } from "react-i18next";
import { LoginType } from "../../types";
import defStyles from "./LoginTabs.module.scss";
import nomadStyles from "./LoginTabs.nomad.module.scss";

const styles =
  process.env.REACT_APP_BRAND === "nomad" ? nomadStyles : defStyles;

interface LoginTabsProps {
  activeType: LoginType;
  onChange: (type: LoginType) => void;
}

const isRockets = process.env.REACT_APP_BRAND === "rockets";

export const LoginTabs = ({ activeType, onChange }: LoginTabsProps) => {
  const { t } = useTranslation("main");

  return (
    <div className={`${styles.select} ${isRockets ? styles.reverse : ""}`}>
      <div
        className={`${styles.selectItem} ${activeType === "phone" && styles.selected}`}
        onClick={() => onChange("phone")}
      >
        {t("phone")}
      </div>
      <div
        className={`${styles.selectItem} ${activeType === "account" && styles.selected}`}
        onClick={() => onChange("account")}
      >
        {t("account")}
      </div>
      <div
        className={`${styles.selectItem} ${activeType === "email" && styles.selected}`}
        onClick={() => onChange("email")}
      >
        E-mail
      </div>
    </div>
  );
};
